import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track } from 'modules/core/lib/Tracking'

import { trainingEvents } from 'modules/trainings/lib/events'

export default function VideoPlayer({ src }: { src: string }) {
  const videoRef = useRef<HTMLVideoElement>(null)
  const location = useLocation()
  const { navigation } = useNavigation()
  const milestonesRef = useRef<Set<number>>(new Set())

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleTimeUpdate = () => {
      if (!video.duration) return
      ;[0, 25, 50, 75, 100].forEach((milestone) => {
        if (
          Math.round((video.currentTime / video.duration) * 100) >= milestone &&
          !milestonesRef.current.has(milestone)
        ) {
          track(trainingEvents.videoTracking.progress, {
            context: context(),
            duration: Math.round(video.duration),
            percentage_watched: milestone,
          })
          milestonesRef.current.add(milestone)
        }
      })
    }

    video.addEventListener('timeupdate', handleTimeUpdate)
    return () => video.removeEventListener('timeupdate', handleTimeUpdate)
  }, [])

  return <video ref={videoRef} controls src={src} style={{ maxWidth: '100%' }} />

  function context() {
    return location.pathname.includes(`/${navigation.myTrainings.path}/`)
      ? 'my_training'
      : location.pathname.includes(
          `/${navigation.trainings.path}/${navigation.trainings.catalog.path}/`
        )
      ? 'catalog'
      : location.pathname.includes(
          `/${navigation.trainings.path}/${navigation.trainings.list.path}/`
        )
      ? 'training'
      : 'training' // default
  }
}
